/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/DesignSystem/LeadPreview/Content/Heading/Title"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let leadStatusValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'status',
})
let constantData = 'dismissed'
let aggregateData = fromAggregate.equals(leadStatusValueData, constantData)
  return (<React.Fragment
>
<div
  data-testid="Title.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-5P3Cr': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 text="Details"
 level="h4"
/>
<fromFlow.When is={aggregateData}>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 type="red"
 alignSelf="center"
 data="lead.status"
 data="'dismissed'"
 aggregate="/Data/aggregate.js equals"
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text="Dismissed"
/>
)}
</TysiaTag>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}